<template lang="pug">
  .component-backoffice
    off-canvas(:menu_pages="menu", :title="title", :action="action", :user="user")
</template>

<script type="text/babel">
  import Routes from '../routes/main.js'
  import {mapState} from 'vuex'

  import OffCanvas from '../components/structure/OffCanvas.vue'

  export default {
    name: 'Backoffice',
    components: {
      OffCanvas,
    },
    computed: {
      ...mapState({
        userStore: state => state.userStore,
      }),
      title: function () {
        if(window && window.env.WHITELABEL_MODE === 'on') {
          return ""
        }
        return 'PLAYMOOVE BOOKING SYSTEM ' + window.env.RELEASE + ' @ ' + window.env.API_URL
      },
      user: function () {
        return this.userStore.user
      },
      menu: function () {
        const routes = Routes[1].children.map((i) => {
          const hasPermission = (menu) => {
            // user is root show all menu voices
            if (this.userIsRoot) {
              return true
            }
            const permission = `_menu_${menu}`
            const allowed = this.menuPermissions.find((item) => {
              return item.name === permission
            })
            return allowed !== undefined && allowed.name === permission
          }

          const hideInMenu = hasPermission(i.path)
          return !hideInMenu ? false : {
            path: i.path,
            name: i.meta.path ? i.meta.path : i.name,
            display_name: i.meta && i.meta.breadcrumb ? i.meta.breadcrumb : 'NO NAME',
            childrens: i.children ? i.children.map(function (i2) {
              return !hasPermission(i.path + '_' + i2.path) || !i2.meta || i2.meta.hideInMenu ? false : {
                path: i2.path,
                name: i2.meta.path ? i2.meta.path : i2.name,
                display_name: i2.meta && i2.meta.breadcrumb ? i2.meta.breadcrumb : 'NO NAME'
              }
            }).filter(function (item) {
              return item
            }) : null
          }
        }).filter(function (item) {
          return item
        })

        return routes
      },
      userIsRoot() {
        const role = this.userStore.user.roles.find((item) => {
          return item.name === 'ROOT'
        })
        return role !== undefined && role.name === 'ROOT'
      },
      userPermissions() {
        const permissions = this.userStore.user.roles.flatMap((item) => {
          return item.permissions
        })
        return permissions
      },
      menuPermissions() {
        const menuPermissions = this.userPermissions.filter((item) => {
          return item.name.startsWith('_menu_')
        })
        return menuPermissions
      },

      action: function () {
        return this.$route.meta.action
      }
    }
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-backoffice
    height: 100%
    width: 100%
</style>



// WEBPACK FOOTER //
// Backoffice.vue?7ad43e1b